// Utility functions for wheel operations

export const wheelUtils = {
  /**
   * Generate a random color based on index
   * @param {number} index - Index for deterministic color generation
   * @returns {string} - Hex color code
   */
  getRandomColor(index) {
    // Default colors if needed
    const colors = [
      '#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', 
      '#9966FF', '#FF9F40', '#C9CBCF', '#7FCA9F',
      '#66CC99', '#FB8072', '#80B1D3', '#FDB462',
      '#B3DE69', '#FCCDE5', '#D9D9D9', '#BC80BD'
    ];
    
    return colors[index % colors.length];
  },
  
  /**
   * Calculate the position of text on the wheel
   * @param {number} angle - Angle in radians
   * @param {number} radius - Radius of the wheel
   * @returns {object} - Position coordinates {x, y}
   */
  calculateTextPosition(angle, radius) {
    return {
      x: Math.cos(angle) * (radius * 0.75),
      y: Math.sin(angle) * (radius * 0.75)
    };
  },
  
  /**
   * Generate random momentum for the wheel spin
   * @returns {number} - Random momentum value
   */
  getSpinMomentum() {
    return 0.1 + (Math.random() * 0.15);
  }
};